function AcademicsSection() {
    return (
        <div>
        <h2 className="left clean-header display-header">{"ACADEMICS"}</h2>
        <hr className="header-hr"/>

        {/* Graduate Degree */}
        <h3 className="display-subheader">Master of Science in Computer Science</h3>
        <p className="display-text" style={{margin: '5px 0'}}>University of Utah | Cumulative GPA: 3.9</p>
        
        <h4 className="display-subheader">Fall 2024</h4>
        <ul className="ulist">
            <li>Natural Language Processing </li>
            <li>Advanced Database Systems </li>
            <li>Visualization for Data Science </li>
            <li>Advanced Seminar: Advances in Generative AI </li>
        </ul>

        <h4 className="display-subheader">Spring 2025</h4>
        <ul className="ulist">
            <li>Data Mining </li>
            <li>Motion Planning </li>
            <li>Network Security </li>
            <li>Advanced Seminar: Mental Health & Technology </li>
        </ul>

        <h4 className="display-subheader">Fall 2025</h4>
        <ul className="ulist">
            <li>Computational Geometry </li>
            <li>Programming Languages </li>
            <li>Computer Architecture </li>
            <li>Seminar: Computer Science Education </li>
        </ul>

        {/* Undergraduate Degree */}
        <h3 className="display-subheader" style={{marginTop: '25px'}}>Bachelor of Science in Computer Science</h3>
        <p className="display-text" style={{margin: '5px 0'}}>University of Utah | Cumulative GPA: 3.7</p>

        <h3 className="display-subheader">Awards</h3>
        <ul className="ulist">
            <li>Dean's List: Fall '19, Fall '21, Fall '22, Spring '23, Fall '23</li>
            <li>Athletics Director Honor Roll, Fall 2019 - Spring 2021</li>
            <li>PAC-12 All-Academic, 2020-2021</li>
            <li>Utah Men's Swim and Dive Most Improved Male 2020</li>
            <li>International Baccalaureate Diploma Recipient</li>
            <li>High School Valedictorian</li>
        </ul>

        <h4 className="display-subheader">Computer Science Courses</h4>
        <ul className="ulist">
            <li>Senior Capstone Project</li>
            <li>Senior Capstone Design</li>
            <li>Models of Computation</li>
            <li>Machine Learning</li>
            <li>Database Systems</li>
            <li>Foundations of Data Analysis</li>
            <li>Design Human Centered Experience</li>
            <li>Web Software Architecture</li>
            <li>Artificial Intelligence</li>
            <li>Computer Systems</li>
            <li>Algorithms</li>
            <li>Image Processing Basics</li>
            <li>Engineering Probability and Statistics</li>
            <li>Software Practice II</li>
            <li>Computer Organization</li>
            <li>Software Practice I</li>
            <li>Discrete Structures</li>
            <li>Intro to Algorithms and Data Structures</li>
            <li>Object-Oriented Programming</li>
        </ul>

        <h4 className="display-subheader">Math & Science Courses</h4>
        <ul className="ulist">
            <li>Linear Algebra</li>
            <li>Calculus III</li>
            <li>Calculus II</li>
            <li>Calculus I</li>
            <li>Physics for Scientists and Engineers I</li>
            <li>Fundamentals of Biology I</li>
        </ul>

        <h4 className="display-subheader">General Education Courses</h4>
        <ul className="ulist">
            <li>History of Rock 'n Roll</li>
            <li>Beginning Spanish I</li>
            <li>Scientific Writing</li>
            <li>Non-Major Basic Drawing</li>
            <li>Digital Content Creation</li>
            <li>Race and Culture</li>
            <li>Latin America</li>
            <li>Intermediate Writing</li>
            <li>American Civilization</li>
        </ul>
        </div>
        
    )
}

export default AcademicsSection;